<p-dropdown [options]="attribute?.Values"
            [(ngModel)]="selected"
            [filter]="true"
            filterBy="Value"
            [showClear]="true"
            [placeholder]="attribute?.Description"
            [style]="{'width':'100%', 'margin-bottom': '1rem'}"
            (onChange)="onChange($event)">
</p-dropdown>
